export default class AnalyticsStore {
  rootStore = null

  constructor(rootStore) {
    this.rootStore = rootStore
    // TODO: revise event names and actual events being sent and where
  }

  get api() {
    return this.rootStore.apiStore
  }

  acceptTermsAndConditions = async () => {
    // return Promise.all([this.#track('Accept_terms_and_conditions'), this.#track('click_on_enter')])

    return this.#track('click_on_enter')
  }

  clickOnAffiliate = async () => this.#track('click_on_affiliate')

  clickOnStore = async () => {
    this.#gtagClickSomewhereOnDashboard()
    this.#gtag('click_signin')
    this.#gtag('create_store')

    return this.#track('signin_page_view')
  }

  clickOnCreateStore = () => this.#gtagClickSomewhereOnDashboard()

  clickOnEditProfile = async () => {
    // return Promise.all([this.#track('click_on_edit_profile'), this.#track('click_on_view_profile')])
    return this.#track('click_on_edit_profile')
  }

  clickOnNewRoom = async () => {
    this.#gtagClickSomewhereOnDashboard()

    return this.#track('click_on_new_room')
  }

  clickOnReports = async () => this.#track('click_on_reports')

  clickOnProfile = async () => {
    this.#gtagClickSomewhereOnDashboard()

    return this.#track('click_on_profile')
  }

  clickOnScheduleLiveStore = async () => {
    this.#gtagClickSomewhereOnDashboard()

    return this.#track('click_on_schedule_live_store')
  }

  clickOnScheduleMeetStore = async () => {
    this.#gtagClickSomewhereOnDashboard()

    return this.#track('click_on_schedule_meet_store')
  }

  clickOnTip = async () => this.#track('click_on_tip')

  clickOnTopup = async () => this.#track('click_on_topup')

  clickOnUploadImageStore = async () => {
    this.#gtagClickSomewhereOnDashboard()

    return Promise.all([
      // this.#track('click_on_upload_image_store'),
      this.#track('click_on_upload_image'),
    ])
  }

  clickOnUploadStreamStore = async () => {
    this.#gtagClickSomewhereOnDashboard()

    return Promise.all([
      // this.#track('click_on_upload_stream_store'),
      this.#track('click_on_upload_stream'),
    ])
  }

  clickOnWallet = async () => {
    this.#gtagClickSomewhereOnDashboard()

    return this.#track('click_on_wallet')
  }

  clickOnMeetWallet = async () => {
    this.#gtagClickSomewhereOnDashboard()

    return this.#track('click_on_meet_wallet')
  }

  clickOnStoreWallet = async () => {
    this.#gtagClickSomewhereOnDashboard()

    return this.#track('click_on_store_wallet')
  }

  clickOnWithdraw = async () => this.#track('click_on_withdraw')

  createStore = async () => {
    this.#trackReddit('Lead')

    return this.#track('create_channel')
  }

  createScheduledMeeting = async () => {
    this.#gtagNewPost()
    this.#trackReddit('AddToCart')

    return this.#track('create_schedule_meeting')
  }

  // customImageSaved = async () => this.#track('custom_image_saved')

  // customCoverSaved = async () => this.#track('custom_cover_saved')

  dashboard = async () => this.#track('Dashboard')

  invitationViewed = async () => {
    this.#trackReddit('StoreInvitation')

    return this.#track('invitation_viewed')
  }

  joinRoom = async id => this.#track('join_room', { hash: id })

  leaveRoomAtEnd = async id => this.#track('leave_room_at_end', { roomname: id })

  leaveRoomFirst = async id => this.#track('leave_room_first', { roomname: id })

  leaveRoomGuestHangup = async id => this.#track('leave_room_guest_hangup', { roomname: id })

  leaveRoomHostHangup = async id => this.#track('leave_room_host_hangup', { roomname: id })

  // nicknameSaved = async () => this.#track('nickname_saved')

  receivePaymentSuccess = async () => this.#track('receive_payment_success')

  saveProfile = async () => this.#track('save_profile')

  send = async (amount, destAddress) => this.#track('send', { amount, destAddress })

  sendPaymentSuccess = async () => this.#track('send_payment_success')

  sendTipSuccess = async () => this.#track('send_tip_success')

  signUp = () => this.#trackReddit('SignUp')

  userReturn = async () => this.#track('user_return')

  // uploadImage = async () => {
  //   this.#gtagNewPost()
  //
  //   return this.#track('upload_image')
  // }

  // uploadVideo = async () => {
  //   this.#gtagNewPost()
  //
  //   return this.#track('upload_video')
  // }

  videoConferenceJoined = async id => this.#track('videoConference_Joined', { hash: id })

  #gtagClickSomewhereOnDashboard = () => this.#gtag('click_somehere_on_dashboard')

  #gtagNewPost = () => this.#gtag('new_post')

  // TODO: these aren't used in BE?
  // apiEventReferer = async () => this.api.sendEvent('referer', { hash: document.referrer })

  // apiEventPlayVideoMobile = async () => this.api.sendEvent('Play_video_mobile')
  // apiEventPlayVideoDesktop = async () => this.api.sendEvent('Play_video_desktop')
  // apiEventCopyInvitationLink = async () => this.api.sendEvent('copy_invitation_link')
  // apiEventCopyInvitationLinkShare = async () => this.api.sendEvent('copy_invitation_link_share')

  // apiEventShareTo = async type => this.api.sendEvent(`share_to_${type}`)
  // apiEventSetAllowanceSuccess = async () => this.api.sendEvent('set_allowance_success')

  // apiEventSetAllowanceFailed = async amount =>
  //   this.api.sendEvent('set_allowance1_failed', { amount })

  // apiEventConnecting1 = async () => this.api.sendEvent('connecting1')

  // apiEventAfterSignin = async hash => this.api.sendEvent('after_signin', { hash })
  // apiEventInvitation = async () => this.api.sendEvent('invitation')
  // apiEventInvitedToStore = async hash => this.api.sendEvent('invited_to_store', { hash })

  // apiEventCreateInstantMeeting = async () => this.api.sendEvent('create_instant_meeting')

  #gtag = event => window.dataLayer?.push({ event })

  #track = async (event, args = {}, platformsOverride = {}) => {
    try {
      const platforms = { api: true, gtag: true, ...platformsOverride }

      const promises = []

      if (platforms.api) promises.push(this.api.sendEvent(event, args))
      if (platforms.gtag) this.#gtag(event)

      return Promise.all(promises)
    } catch (e) {
      console.error(`[Analytics] Error tracking event "${event}"`, e)

      return null
    }
  }

  #trackReddit = event => {
    try {
      // eslint-disable-next-line no-undef
      if (rdt) rdt('track', event)
    } catch {
      // noop
    }
  }
}
